export default __webpack_public_path__ + "static/media/offroad90000.fff343e3.jpg";